import { render, staticRenderFns } from "./distributionSpecialist.vue?vue&type=template&id=f27de9d8&scoped=true"
import script from "./distributionSpecialist.vue?vue&type=script&lang=js"
export * from "./distributionSpecialist.vue?vue&type=script&lang=js"
import style0 from "./distributionSpecialist.vue?vue&type=style&index=0&id=f27de9d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27de9d8",
  null
  
)

export default component.exports